<template>
  <svg class="favorite-icon" viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M12 2l2.81 6.63 7.19.61-5.46 4.73L18.18 21 12 17.27 5.82 21l1.64-7.03L2 9.24l7.19-.61L12 2z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "FavoriteIcon",
};
</script>

<style scoped>
.favorite-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  vertical-align: middle;
  color: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/common/FavoriteIcon.vue